import React from 'react';
import { Box, CheckFilledIcon } from '@common-fe/common-fe';

import theme from '@/styles/theme';

interface Props {
  children?: React.ReactNode;
  onClose?: () => void;
}

const VerifyBlock: React.FC<Props> = ({ children, onClose }) => {
  return (
    <Box
      direction="row"
      pad={{ vertical: 'spacing8', horizontal: 'spacing12' }}
      round="snackbarRound"
      align="center"
      background="success"
    >
      <Box margin={{ left: 'spacing4', right: 'spacing12' }}>
        <CheckFilledIcon color={theme.colors.textOnColor} />
      </Box>
      <Box justify="center" fill>
        {children}
      </Box>
      {/* <RawButton onClick={onClose}>
        <Box margin={{ right: 'spacing4' }}>
          <LargeCloseIcon />
        </Box>
      </RawButton> */}
    </Box>
  );
};

export default VerifyBlock;
